// TableContainer's active tab, kept at module scope so it survives switching views; consumers narrow it to their TabId.
export const tableViewStore = $state({ activeTab: '' });
